import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { MatDialog } from "@angular/material";
import * as moment from "moment";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { ProperJsonDialogComponent } from "../properJsonDialog/properjsondialog.component";
import { AddPayoutTopupDialog } from "./add-payout-topup/add-payout-topup.component";
import { TableUtil } from "../admintrademaster/tableUtil";
import { amountFormatter } from "../custompipes/amount-formatter";

@Component({
  selector: "app-payout-topup",
  templateUrl: "./payout-topup.component.html",
  styleUrls: ["./payout-topup.component.css"],
})
export class PayoutTopupComponent implements OnInit {
  _csrf: string;
  request_id: string = "";

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
  };

  topups: any = [];
  oTopups: any = [];
  searchValue: string = "";
  filter: any = {
    page: 1,
    limit: 100,
    fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    userId: "",
  };
  prev_disabled = true;
  next_disabled = false;

  userList: any[] = [];
  filteredUserList: any[] = [];
  userSearchValue: string = "";
  isUserSelectOpen: boolean = false;

  totalCryptoCredit: number = 0;
  totalCreditAmount: number = 0;
  totalCryptoReceived: number = 0;
  get netCrypto(): number {
    return this.totalCryptoCredit - this.totalCryptoReceived;
  }

  myFilter = (d: Date | null): boolean => true;

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  loadUserList() {
    if (!this._csrf) {
      return;
    }

    const filter = {
      _csrf: this._csrf,
      perpage: 10000,
      page: 1,
      search: "",
      status: "Active",
    };

    this.offrampService.getOfframpCustomerList(filter).subscribe(
      (response: any) => {
        if (response && response.customers && Array.isArray(response.customers)) {
          this.userList = response.customers;
        } else if (response && Array.isArray(response)) {
          this.userList = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.userList = response.data;
        } else {
          this.userList = [];
        }
        this.filteredUserList = this.userList;
      },
      () => {
        this.userList = [];
        this.filteredUserList = [];
      }
    );
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: "Action",
        field: "action",
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement("div");
          container.style.display = "flex";
          container.style.alignItems = "center";

          const viewBtn = document.createElement("button");
          viewBtn.type = "button";
          viewBtn.className = "btn btn-sm btn-info";
          viewBtn.title = "View";
          viewBtn.style.marginRight = "5px";
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element, "Payout Topup");
          };
          container.appendChild(viewBtn);

          const editBtn = document.createElement("button");
          editBtn.type = "button";
          editBtn.className = "btn btn-sm btn-primary";
          editBtn.title = "Edit";
          editBtn.style.marginRight = "5px";
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 140,
      },
      {
        headerName: "User",
        field: "UserId.name",
        valueGetter: (params) => {
          if (params.data && params.data.UserId && params.data.UserId.name) {
            return params.data.UserId.name;
          }
          return "";
        },
        flex: 1,
      },
      {
        headerName: "As Of Date",
        field: "AsOfDate",
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format("MMM DD, YYYY");
          }
          return "";
        },
        flex: 1,
      },
      { headerName: "Credit Batch ID", field: "CreditBatchId", flex: 1 },
      { headerName: "Credit Crypto", field: "CryptoCredit", flex: 1 },
      { headerName: "Crypto Received", field: "CryptoReceived", flex: 1, },
      { headerName: "Rate", field: "Rate", flex: 1 },
      { headerName: "Credit Amount", field: "CreditAmount", flex: 1, valueFormatter: amountFormatter },
      { headerName: "Used Amount", field: "UsedAmount", flex: 1, valueFormatter: amountFormatter },
      {
        headerName: "Balance Amount",
        field: "Balance",
        flex: 1,
        valueFormatter: amountFormatter,
        // Highlight the remaining balance of inactive topups
        cellStyle: (params) => (params.data && params.data.IsActive === false)
          ? { background: '#ffcdd2', color: '#b71c1c', fontWeight: 600 }
          : null,
      },
      { headerName: "AvgPrice", field: "AvgPrice", flex: 1 },
      {
        headerName: "Settlement Status",
        field: "SettlementStatus",
        flex: 1,
        cellStyle: (params) => this.getStatusCellStyle(params.value),
      },
      { headerName: "Currency", field: "Currency", flex: 1 },
      { headerName: "Crypto Currency", field: "CryptoCurrency", flex: 1 },
      { headerName: "Matched Amount", field: "MatchedTradeAmount", flex: 1 },
      {
        headerName: "Matched Status",
        field: "MatchedStatus",
        flex: 1,
        cellStyle: (params) => this.getStatusCellStyle(params.value),
      },
      {
        headerName: "Credit Status",
        field: "CreditStatus",
        flex: 1,
        cellStyle: (params) => this.getStatusCellStyle(params.value),
      },
      { headerName: "Payment Method", field: "PaymentMethod", flex: 1 },
      { headerName: "Txn Status", field: "TxnStatus", flex: 1 },
      {
        headerName: "CreatedAt",
        field: "createdAt",
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format("MMM DD, YYYY hh:mm:ss A");
          }
          return "";
        },
        flex: 1.5,
      },
      {
        headerName: "Client Quote",
        field: "client_quote_id",
        valueGetter: (params) => {
          const quote = params.data && params.data.client_quote_id;
          if (!quote) return '';
          return `${quote.from_currency || ''} -> ${quote.to_currency || ''} @ ${quote.rate || 0}`;
        },
        flex: 1.5,
      },
    ];

    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
    };
  }

  private getStatusCellStyle(status: string) {
    if (status === 'PARTIAL') {
      return { background: '#fff9c4' };
    }
    if (status !== 'COMPLETED') {
      return { background: '#ffe6e6' };
    }
    return null;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.loadUserList();
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  fromDateFilter(event: any, type: Number = 1) {
    if (event.value) {
      if (type == 1) {
        this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
      }
    }
  }

  toDateFilter(event: any) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  applyFilter(filterValue) {
    this.searchValue = filterValue || "";
    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }
    this.applyFilterToLocalData(this.searchValue);
  }

  clearSearch() {
    this.searchValue = "";
    this.applyFilter("");
  }

  applyFilterToLocalData(searchValue: string) {
    if (searchValue) {
      const search = searchValue.toLowerCase();
      this.topups = this.oTopups.filter((x: any) => {
        return (
          (x.TxnId && x.TxnId.toLowerCase().includes(search)) ||
          (x.Currency && x.Currency.toLowerCase().includes(search)) ||
          (x.PaymentMethod && x.PaymentMethod.toLowerCase().includes(search)) ||
          (x.Note && x.Note.toLowerCase().includes(search)) ||
          (x.UserId && x.UserId.name && x.UserId.name.toLowerCase().includes(search))
        );
      });
    } else {
      this.topups = this.oTopups;
    }
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.userService.getAllPayoutTopup(this.filter).subscribe((list: any) => {
      this.topups = list;
      this.oTopups = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
        if (this.searchValue) {
          this.gridApi.setQuickFilter(this.searchValue);
          this.applyFilterToLocalData(this.searchValue);
        } else {
          this.gridApi.setQuickFilter("");
          this.topups = this.oTopups;
        }
      }

      this.spinnerService.hide();
      if (this.filter.page <= 1) {
        this.prev_disabled = true;
      } else {
        this.prev_disabled = false;
      }
      if (!list || list.length < this.filter.limit) {
        this.next_disabled = true;
      } else {
        this.next_disabled = false;
      }
    });

    this.userService.getPayoutTopupSummary(this.filter).subscribe((response: any) => {
      this.totalCryptoCredit = response && response.totalCryptoCredit ? response.totalCryptoCredit : 0;
      this.totalCreditAmount = response && response.totalCreditAmount ? response.totalCreditAmount : 0;
      this.totalCryptoReceived = response && response.totalCryptoReceived ? response.totalCryptoReceived : 0;
    });
  }

  exportArray() {
    this.spinnerService.show();

    // Fetch fresh with a large limit (ignoring current page) so the export isn't capped to one page
    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      userId: this.filter.userId || "",
      page: 1,
      limit: 5000,
    };

    this.userService.getAllPayoutTopup(exportFilter).subscribe(
      (list: any) => {
        if (list && list.length > 0) {
          const exportData = list.map((x: any) => ({
            ...x,
            UserId: x.UserId ? x.UserId._id : '',
            UserName: x.UserId ? x.UserId.name : '',
          }));
          TableUtil.exportArrayToExcel(exportData, 'PayoutTopup');
        } else {
          this.notifSer.info("Info", "No data available to export", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.notifSer.error("Error", "Failed to export data. Please try again.", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.spinnerService.hide();
      }
    );
  }

  displayProperJson(jsonData, eventType) {
    const obj = {
      jsonData: jsonData,
      eventType: eventType || "Payout Topup",
    };
    this.dialog
      .open(ProperJsonDialogComponent, {
        width: "auto",
        height: "auto",
        data: obj,
      })
      .afterClosed()
      .subscribe(() => { });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      fromDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      userId: "",
    };
    this.searchValue = "";
    this.userSearchValue = "";
    this.filteredUserList = this.userList;
    if (this.gridApi) {
      this.gridApi.setQuickFilter("");
    }
    this.topups = this.oTopups;
    this.getData();
  }

  onUserSelectOpened(isOpen: boolean) {
    this.isUserSelectOpen = isOpen;
    if (isOpen) {
      this.userSearchValue = "";
      this.filteredUserList = this.userList;
      setTimeout(() => {
        this.addSearchToSelectPanel();
      }, 150);
    } else {
      this.userSearchValue = "";
      this.filteredUserList = this.userList;
    }
  }

  addSearchToSelectPanel() {
    const panel = document.querySelector(".user-select-panel-payout-topup-list");
    if (panel) {
      const existingSearch = panel.querySelector(".user-search-container");
      if (existingSearch) {
        existingSearch.remove();
      }

      const searchContainer = document.createElement("div");
      searchContainer.className = "user-search-container";
      searchContainer.innerHTML = `
        <input type="text" placeholder="Search user..." class="user-search-input" value="${this.userSearchValue || ""}">
      `;

      const searchInput = searchContainer.querySelector(".user-search-input") as HTMLInputElement;
      if (searchInput) {
        searchInput.addEventListener("input", (e: any) => {
          this.userSearchValue = e.target.value;
          this.filterUsers(e);
        });
        searchInput.addEventListener("click", (e: any) => {
          e.stopPropagation();
        });
        searchInput.addEventListener("keydown", (e: any) => {
          e.stopPropagation();
        });
      }

      if (panel.firstChild) {
        panel.insertBefore(searchContainer, panel.firstChild);
      } else {
        panel.appendChild(searchContainer);
      }

      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 50);
      }
    }
  }

  filterUsers(event: any) {
    const searchTerm = event ? (event.target ? event.target.value : event) : this.userSearchValue;
    this.userSearchValue = searchTerm || "";

    if (!searchTerm || searchTerm.trim() === "") {
      this.filteredUserList = this.userList;
      return;
    }

    const term = searchTerm.toLowerCase();
    this.filteredUserList = this.userList.filter((user) => {
      const name = (user.name || "").toLowerCase();
      const email = (user.email || "").toLowerCase();
      return name.includes(term) || email.includes(term);
    });
  }

  addNewRecord() {
    const newRecord = {
      UserId: "",
      CreditAmount: 0,
      UsedAmount: 0,
      CreditBatchId: "NEXT",
      Currency: "INR",
      CryptoCurrency: "USDT",
      CryptoCredit: 0,
      CryptoReceived: 0,
      PaymentMethod: "",
      TxnId: "",
      TxnStatus: "COMPLETED",
      Note: "",
    };

    const dialogRef = this.dialog.open(AddPayoutTopupDialog, {
      width: "600px",
      maxWidth: "90vw",
      data: { record: newRecord, _csrf: this._csrf },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.notifSer.success("Success", "Topup record added successfully", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.getData();
      }
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddPayoutTopupDialog, {
      width: "600px",
      maxWidth: "90vw",
      data: { record: record, _csrf: this._csrf },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.notifSer.success("Success", "Topup record updated successfully", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.getData();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/payout-topup/payout-topup.component.ts